// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"622ff532","103":"8af23314","664":"66320759","695":"279ef5ef","808":"c6ffaf56"}[chunkId] + ".chunk.js";
};